module.exports = __webpack_public_path__ + "img/web2.adf14fb8.png";